import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import { Form, Modal } from "react-bootstrap";

import Select from "react-select";

import {
  getExaminationResultFile,
  restExaminationResultFile,
} from "../../../redux/inspectionTechnicalConditionBasesReducer/actionsInspectionTechnicalConditionBases";

import {
  getDataExaminationResultModal,
  getDataExaminationResultViewModal,
  headerName,
  setDataForExaminationResult,
  customStyles,
  customErrorStyles,
} from "./constantsExaminationResultModal";

import {
  API_ADD_REVESION_BASES,
  API_UPLOAD_FILE_BASES,
  MAIN_URL,
  PORT,
} from "../../../constants/constants";

import styles from "./addExaminationResultModal.module.css";

function AddExaminationResultModal({ setShow, show, type, setSave }) {
  const dispatch = useDispatch();

  const [dataForm, setDataForm] = useState({ ownerLeName: 0 });
  const [errors, setErrors] = useState({});
  const [fields, setFields] = useState([]);
  const [foundObject, setFoundObject] = useState({});
  const [file, setFile] = useState(null);

  const selectedObject = useSelector((state) => {
    const { inspectionTechnicalConditionBasesReducer } = state;
    return inspectionTechnicalConditionBasesReducer.selectedObject;
  });
  const getFileResults = useSelector((state) => {
    const { inspectionTechnicalConditionBasesReducer } = state;
    return inspectionTechnicalConditionBasesReducer.file;
  });
  const dataForTableConditionBases = useSelector((state) => {
    const { inspectionTechnicalConditionBasesReducer } = state;
    return inspectionTechnicalConditionBasesReducer.data;
  });
  const getCheckStatus = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.newNsiCheckStatus;
  });

  const handleClose = (event) => {
    let buttonType;
    if (event) {
      buttonType = event.target.dataset.type;
    }

    if (!editErrors(buttonType)) {
      setShow(false);
    }
  };

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const viewDataModal = () => {
    if (selectedObject) {
      // let newDateString = "";
      // if (selectedObject.checkDate) {
      //   const parts = selectedObject.checkDate.split("-");
      //   newDateString = parts[2] + "." + parts[1] + "." + parts[0];
      // }

      setDataForm(() => ({
        ...dataForm,
        ownerLeName: selectedObject.ownerLeName,
        section: selectedObject.sectionName,
        ownerAddress: selectedObject.ownerAddress,
        ownerPhone: selectedObject.ownerPhone,
        location: selectedObject.location,
        phone1: selectedObject.phone1,
        phone2: selectedObject.phone2,
        responFio: selectedObject.responFio,
        responPosition: selectedObject.responPosition,
        examinationDate: selectedObject.checkDate,
        checkStatus: selectedObject.statusName,
      }));
    }
  };

  const findButtonClick = () => {
    setDataForm(() => ({
      ...dataForm,
      section: foundObject.sectionName,
      ownerAddress: foundObject.ownerAddress,
      ownerPhone: foundObject.ownerPhone,
      location: foundObject.location,
      phone1: foundObject.phone1,
      phone2: foundObject.phone2,
      responFio: foundObject.responFio,
      responPosition: foundObject.responPosition,
    }));
  };

  const editErrors = (buttonType) => {
    if (buttonType === "save") {
      const { examinationDate, checkStatus } = dataForm;
      const newErrors = {};
      if (!examinationDate || examinationDate === "")
        newErrors.examinationDate = "Заполните дату последнего обследования";
      if (new Date(examinationDate) > new Date())
        newErrors.examinationDate = "Дата не может быть позднее текущей";
      if (!checkStatus || checkStatus === "")
        newErrors.checkStatus = "Заполните результат последнего обследования";
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return true;
      } else {
        return false;
      }
    } else return false;
  };

  const handleSaveClick = async () => {
    if (editErrors("save")) return;
    const baseId = foundObject.parkId;

    const data = {
      checkDate: dataForm.examinationDate,
      checkStatus: dataForm.checkStatus,
    };
    if (file !== undefined && file !== null) {
      const formData = new FormData();

      formData.append(`file`, file);

      const fileRequest = await fetchWithToken(
        MAIN_URL + PORT + API_UPLOAD_FILE_BASES + baseId,
        {
          method: "POST",
          body: formData,
        },
      );
      if (fileRequest.status === 200) {
        const response = await fileRequest.json();
        data.checkDoc = response;
      } else {
        console.error(`Error: ${fileRequest.status}`);
      }
    }

    const addRequest = await fetchWithToken(
      MAIN_URL + PORT + API_ADD_REVESION_BASES + baseId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );
    if (addRequest.status !== 200) {
    } else {
      const response = await addRequest.text();
    }
    setSave();
    setShow(false);
  };

  async function setParamsForOptions() {
    await setDataForExaminationResult(
      dataForTableConditionBases,
      "ownerLeName",
    );
    await setDataForExaminationResult(getCheckStatus, "checkStatus");

    if (type === "add")
      setFields(Object.values(getDataExaminationResultModal()));
    else setFields(Object.values(getDataExaminationResultViewModal()));
  }

  async function handleChangeSelectSearch(event) {
    if (event) {
      const newDataForm = { ...dataForm };
      newDataForm[event.key] = event.value;
      setDataForm(newDataForm);
      switch (event.key) {
        case "ownerLeName": {
          setFoundObject(
            dataForTableConditionBases.find(
              (obj) => obj.parkId === event.value,
            ),
          );
          break;
        }
        default:
          break;
      }
    }
  }

  useEffect(() => {
    setParamsForOptions().then();
  }, [dataForm]);

  useEffect(() => {
    if (type === "view") viewDataModal();

    dispatch(restExaminationResultFile());
    if (selectedObject && selectedObject.checkDoc)
      dispatch(
        getExaminationResultFile(
          selectedObject.parkId,
          selectedObject.checkDoc,
        ),
      );
  }, [selectedObject]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>
          {headerName[type]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form className={styles.container}>
          <div className={`${styles["box-findButton"]}`}>
            {type === "add" && (
              <div
                onClick={findButtonClick}
                className={styles["custom-button"]}
                data-type={`find`}
                disabled={type !== "add"}
              >
                <span className={styles["custom-icon"]}></span>
                <span>{"Найти"}</span>
              </div>
            )}
          </div>
          {fields.map((el) => {
            if (el.type === "selectSearch") {
              return (
                <Form.Group key={el.key} className={styles[`box-${el.key}`]}>
                  <Form.Label className={styles["label"]}>
                    {el.label}
                    {el.required && type !== "view" && (
                      <span className={styles["red-dot"]}>*</span>
                    )}
                  </Form.Label>
                  <Select
                    noOptionsMessage={() => "Нет данных"}
                    value={el.options.find(
                      (item) => item.value === dataForm?.[el.key] || null,
                    )}
                    classNamePrefix="custom-select"
                    styles={!!errors[el.key] ? customErrorStyles : customStyles}
                    onChange={(e) => handleChangeSelectSearch(e)}
                    placeholder="Выберите"
                    id={el.key}
                    isSearchable={el.isSearchable}
                    isDisabled={el.isDisabled || type === "view"}
                    name={el.key}
                    options={el.options}
                  />
                  {errors[el.key] && (
                    <div style={{ color: "red" }}>{errors[el.key]}</div>
                  )}
                </Form.Group>
              );
            } else {
              return (
                <Form.Group key={el.key} className={styles[`box-${el.key}`]}>
                  <Form.Label className={styles["label"]}>
                    {el.label}
                    {el.required && type !== "view" && (
                      <span className={styles["red-dot"]}>*</span>
                    )}
                  </Form.Label>
                  <input
                    id={el.key}
                    disabled={el.disabled || type !== "add"}
                    className={`${styles["form-input"]} ${
                      errors[el.key] ? styles["error-border"] : ""
                    }`}
                    type={el.type}
                    value={(dataForm && dataForm[el.key]) || ""}
                    onChange={(e) => {
                      dataForm[e.currentTarget.id] = e.currentTarget.value;
                      setDataForm(structuredClone(dataForm));
                    }}
                  />
                  {errors[el.key] && (
                    <div style={{ color: "red" }}>{errors[el.key]}</div>
                  )}
                </Form.Group>
              );
            }
          })}
          {type === "add" && (
            <div
              className={`${styles["box-additionalText"]} ${styles["label"]}`}
            >
              Приложение
            </div>
          )}
          {type === "add" && (
            <div className={`${styles["box-additionalFile"]}`}>
              <>
                <label className={styles["input-file"]}>
                  <span className={styles["input-file-btn"]}>
                    Выберите файл
                  </span>
                  {!file?.name && (
                    <input
                      type="file"
                      name="file"
                      accept={".doc,.docx,.pdf"}
                      onChange={(e) => handleFile(e)}
                    />
                  )}
                  <span className={styles["input-file-text"]} type="text">
                    <span className={styles["file-name"]}>
                      {file?.name || "Не выбрано"}
                    </span>
                    <div className={styles["icons-block"]}>
                      {file?.name && (
                        <span
                          onClick={(e) => clearFile(e)}
                          className={styles["delete-icon"]}
                        ></span>
                      )}
                      <span className={styles["paperclip"]}></span>
                    </div>
                  </span>
                </label>
              </>
            </div>
          )}
          {type === "view" && getFileResults && (
            <div className={`${styles["box-additionalFile"]}`}>
              <div className={styles["text-block-view-file"]}>
                <a
                  className={styles["option-value-view"]}
                  href={getFileResults.url}
                  target="_blank"
                >
                  {"Файл предписания"}
                </a>
              </div>
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        {type !== "view" && (
          <div
            disabled={type !== "add"}
            data-type={`save`}
            className={styles["save-btn"]}
            onClick={handleSaveClick}
          >
            Сохранить
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default AddExaminationResultModal;
